module.exports = __webpack_public_path__ + "static/media/Icon-battery.9ed94ff1.svg";